import { signInWithOtp } from "../../lib/auth";
import { portalMode } from "../../lib/host";

/**
 * Redirect URL embedded in every magic-link email.
 * The SPA picks up the session token from the URL hash on landing.
 * Register these values in Supabase → Authentication → URL Configuration →
 * "Redirect URLs" — a wildcard per host (`https://portal.zooylo.app/**` and
 * `https://admin.zooylo.app/**`) covers both callbacks.
 *
 * Both build from `window.location.origin`, so the link always returns to the
 * host the person signed in from — the whole point of the two-domain split.
 */
export function serviceRedirectUrl(): string {
  return `${window.location.origin}/auth/callback`;
}

/**
 * On admin.zooylo.app the admin portal IS the root, so its callback is
 * `/auth/callback` too; on a dual host (localhost, preview deploys) the admin
 * tree still lives under `/admin`, so the callback must stay there or the
 * caregiver gate would swallow the session and land the admin in the wrong app.
 */
export function adminRedirectUrl(): string {
  const suffix =
    portalMode() === "admin" ? "/auth/callback" : "/admin/auth/callback";
  return `${window.location.origin}${suffix}`;
}

/** Calls signInWithOtp and normalises the result to a plain error string. */
export async function sendMagicLink(
  email: string,
  redirectTo: string,
): Promise<{ error: string | null }> {
  const { error } = await signInWithOtp(email, { redirectTo });
  if (error) {
    return { error: error.message || "Something went wrong. Please try again." };
  }
  return { error: null };
}
